import * as CandidateApi from '../../api/CandidateApi';
import { ApiResponse } from '../../api/CustomFetch';
import { AddCandidateEdiIdsViewModel } from '../../model/AddCandidateEdiIdsViewModel';
import CustomDraggableDialog from '../common/customDialog/CustomDraggableDialog';
import UploadDropZone from '../common/UploadDropZone';
import TranslatedMessage from '../translations/TranslatedMessage';
import { makeStyles } from '@material-ui/core';
import React from 'react';
import { FileWithPreview } from 'react-dropzone';

interface ImportEdiIdsDialogProps {
    isOpen: boolean;
    onUploadError: () => void;
    onFileUploaded: (file: FileWithPreview, response: ApiResponse<AddCandidateEdiIdsViewModel>) => void;
    onClose: () => void;
}

const useStyles = makeStyles(() => ({
    dropZoneDiv: { width: '100%', marginLeft: 'auto', marginRight: 'auto' }
}));

const ImportEdiIdsDialog: React.FunctionComponent<ImportEdiIdsDialogProps> = ({ isOpen, onFileUploaded, onUploadError, onClose }) => {
    const classes = useStyles();

    return <CustomDraggableDialog
        hideActions={true}
        onClose={onClose}
        acceptText={<TranslatedMessage id="common.accept" />}
        cancelText={<TranslatedMessage id="common.cancel" />}
        content={<React.Fragment>
            <div className={classes.dropZoneDiv}>
                <UploadDropZone
                    accept=".csv"
                    onUploadError={onUploadError}
                    onFileUploaded={onFileUploaded}
                    uploadURL={CandidateApi.ediIdsImportUrl}
                />
            </div>
        </React.Fragment>
        }
        isOpen={isOpen}
        title={<TranslatedMessage id="candidate.ediIdsDialog.title" />} />;
};

export default ImportEdiIdsDialog;